//创建单页面组件
import { createApp } from 'vue'
import App from './App.vue'
import axios from 'axios'
import { createRouter,createWebHashHistory } from "vue-router"
import RouterList from './router'
import ElementPLUS from "element-plus"
import TTLLoading from '@/components/Loading.vue'
import Navigation from '@/components/Navigation.vue'
import UploadImage from '@/components/files.vue'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import 'element-plus/dist/index.css'  //组件样式
import Method from '@/Library/method' //公共函数
import JUMPMethod from '@/Library/jumpview' //跳转组件函数
import LOCALDATA from '@/Library/localData' //本地数据组件
import { ElNotification,ElMessageBox } from 'element-plus';
import locale from 'element-plus/es/locale/lang/zh-cn'; //加载中文语言包
import "@/style/common.scss";  //自定义样式表

//引入自定义组件并加载
import wcinput from '@/components/tools/INPUT';
import wcinputprex from '@/components/tools/INPUTPREX';
import wcselect from '@/components/tools/SELECT';
import wccascader from '@/components/tools/CASCADER';
import wccitycascader from '@/components/tools/CITYCASCADER';
import wctime from '@/components/tools/TIME';
import wcbutton from '@/components/tools/BUTTON';
import wccheckbox from '@/components/tools/CHECKBOX';
import wccheck from '@/components/tools/CHECK';
import wcradio from '@/components/tools/RADIO';
import wcpage from '@/components/tools/PAGE';
import wcupload from '@/components/tools/UPLOAD';
import wcvideoupload from '@/components/tools/VEDIOUPLOAD';
import wcvideo from '@/components/tools/VEDIO';
import wcuploadmore from '@/components/tools/UPLOADMORE';
import wcimage from '@/components/tools/IMAGE';
import wcpercent from '@/components/tools/PERCENT';


//视频播放
import vue3videoPlay from 'vue3-video-play' // 引入组件
import 'vue3-video-play/dist/style.css' // 引入css


const app=createApp(App);
app.use(ElementPLUS,{locale});  //加载Element-ui
app.use(vue3videoPlay); //视频组件


//加载自定义组件
app.component('wcinput', wcinput);
app.component('wcinputprex', wcinputprex);
app.component('wcselect', wcselect);
app.component('wccascader', wccascader);
app.component('wccitycascader', wccitycascader);
app.component('wctime', wctime);
app.component('wcbutton', wcbutton);
app.component('wccheck', wccheck);
app.component('wccheckbox', wccheckbox);
app.component('wcradio', wcradio);
app.component('wcpage', wcpage);
app.component('wcupload', wcupload);
app.component('wcvideo', wcvideo);
app.component('wcvideoupload', wcvideoupload);
app.component('wcuploadmore', wcuploadmore);
app.component('wcimage', wcimage);
app.component('wcpercent', wcpercent);



//注册全局参数
app.config.globalProperties.$http = axios;  //http参数提交组件
app.config.globalProperties.$loading = TTLLoading; //loading模块
app.config.globalProperties.$navigation = Navigation; //菜单导航模块
app.config.globalProperties.$uploadimage = UploadImage; //图片模块

app.config.globalProperties.$notice = ElNotification; //消息提醒
app.config.globalProperties.$confirm = ElMessageBox; //消息提示框
app.config.globalProperties.$method = Method; //加载公共函数
app.config.globalProperties.$JUMPMethod = JUMPMethod; //加载跳转函数
app.config.globalProperties.$LOCALDATA = LOCALDATA; //加载跳转本地参数函数
app.config.globalProperties.$ImageAddress = process.env.VUE_APP_IMAGE_ADDRESS; //设置图片访问地址信息


//加载element-ui组件
for(const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}

//获取路由列表
const routes=RouterList;
//创建路由
const router = createRouter({
    //设置路由模式为hash模式
    history: createWebHashHistory(),
    routes: routes
})

//防止页面重复渲染
const debounce = (fn, delay) => {
    let timer = null;
    return function () {
        let context = this;
        let args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
            fn.apply(context, args);
        }, delay);
    }
}
const _ResizeObserver = window.ResizeObserver;
    window.ResizeObserver = class ResizeObserver extends _ResizeObserver{
    constructor(callback) {
        callback = debounce(callback, 16);
        super(callback);
    }
}

app.use(router);
app.mount('#app');  //将App组件渲染到id为app的标签中  

